<script lang="ts" setup>
import { computed } from 'vue'

import { useSportOptions } from '@mobile/views/Relation/DetailsPanel/Sports/composables/useSportOptions'
import { useEventRelationSettings } from '@mobile/views/Relation/DetailsPanel/Sports/useEventRelationSettings'
import Table from '@mobile/views/Relation/DetailsPanel/Table/Table.vue'
import { useHistoryIncidents } from '@mobile/views/Relation/DetailsPanel/Table/useHistoryIncidents'
import { useIncidentResult } from '@mobile/views/Relation/Shared/IncidentResult'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import { useSportConfiguration } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/useSportConfiguration'

import HistoryItem from './HistoryItem.vue'

const eventInjections = useEventInjections()
const { eventClockConfiguration } = useSportConfiguration()
const sportOptionsComposable = useSportOptions(eventInjections.sport)
const { linkedProbableIncidents } = eventInjections
const { pinnedIncidentIds } = useHistoryIncidents(eventInjections)
const { enableFilters, hideIncidents } = useEventRelationSettings(
  eventInjections,
  sportOptionsComposable,
)

const { getResult } = useIncidentResult()

const pinnedIncidents = computed(() => {
  let incidents = linkedProbableIncidents.value
  if (hideIncidents.value.length && enableFilters.value) {
    incidents = incidents
      .filter((incident) =>
        hideIncidents.value.every(
          (hideIncident) => hideIncident !== incident.incident.incident_id,
        ),
      )
      .filter((probableIncident) =>
        pinnedIncidentIds.value.some(
          (incidentId) => incidentId === probableIncident.incident.id,
        ),
      )
  }
  return incidents.filter((probableIncident) =>
    pinnedIncidentIds.value.some(
      (incidentId) => incidentId === probableIncident.incident.id,
    ),
  )
})
</script>

<template>
  <Table :showEventTime="eventClockConfiguration.isEnabled">
    <HistoryItem
      v-for="linkedIncident of pinnedIncidents"
      :key="`pinned-incident-${linkedIncident.incident.id}`"
      :linkedIncident
      :dockable="false"
      :result="getResult(linkedIncident.incident)"
      pinned
    />
  </Table>
</template>
